/* ==========================================================================
   KINGBINK · Outfit — tienda: bolsa, producto, colección, recomendaciones
   ========================================================================== */
(function () {
  'use strict';

  var d = document, w = window, root = d.documentElement;
  var KB = w.KB = w.KB || {};
  var S = KB.strings || {};
  var routes = KB.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var money = function (cents) {
    var cur = KB.currency || 'CLP';
    try {
      return new Intl.NumberFormat(cur === 'CLP' ? 'es-CL' : (KB.locale || undefined), { style: 'currency', currency: cur, maximumFractionDigits: cur === 'CLP' ? 0 : 2, minimumFractionDigits: cur === 'CLP' ? 0 : 2 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  };

  /* ---------- Aviso ---------- */
  var toastEl = $('[data-kb-toast]'), toastTimer = 0;
  function toast(msg, isError, linkLabel, linkHref) {
    if (!toastEl) return;
    toastEl.textContent = '';
    var s = d.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (linkLabel) { var a = d.createElement('a'); a.href = linkHref || routes.cart; a.textContent = linkLabel; toastEl.appendChild(a); }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-on');
    w.clearTimeout(toastTimer);
    toastTimer = w.setTimeout(function () { toastEl.classList.remove('is-on'); }, isError ? 6000 : 4200);
  }
  KB.toast = toast;

  /* ---------- Bolsa lateral ---------- */
  var drawer = $('[data-kb-drawer]');
  var drawerFocus = null;
  function drawerOpen() {
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false') return;
    drawerFocus = d.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    if (KB.lock) KB.lock(true);
    var p = $('.kb-drawer__panel', drawer); if (p) p.focus({ preventScroll: true });
  }
  function drawerClose() {
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    drawer.setAttribute('aria-hidden', 'true');
    if (KB.lock) KB.lock(false);
    if (drawerFocus && drawerFocus.focus) drawerFocus.focus({ preventScroll: true });
  }
  KB.openCart = drawerOpen;

  function setCount(n) {
    $$('[data-kb-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.add('is-bump');
      w.setTimeout(function () { el.classList.remove('is-bump'); }, 420);
    });
  }
  function renderDrawer(html) {
    if (!drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = $('[data-kb-drawer-inner]', doc), cur = $('[data-kb-drawer-inner]', drawer);
    if (!next || !cur) return;
    cur.replaceWith(next);
    setCount(parseInt(next.getAttribute('data-count'), 10) || 0);
    if (KB.scan) KB.scan(drawer);
  }
  function addToCart(payload) {
    var headers = { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
    var body;
    if (payload instanceof FormData) {
      payload.append('sections', 'cart-drawer'); payload.append('sections_url', w.location.pathname);
      body = payload;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: w.location.pathname }, payload));
    }
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: headers, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || S.error || 'Error');
        if (res.j.sections && res.j.sections['cart-drawer']) renderDrawer(res.j.sections['cart-drawer']);
        else w.location.href = routes.cart;
        return res.j;
      });
  }
  function changeLine(line, qty) {
    var inner = $('[data-kb-drawer-inner]', drawer); if (inner) inner.classList.add('is-busy');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty), sections: 'cart-drawer', sections_url: w.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.sections && j.sections['cart-drawer']) renderDrawer(j.sections['cart-drawer']); else w.location.reload();
    }).catch(function () { w.location.reload(); });
  }

  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var toggle = t.closest('[data-kb-cart-toggle]');
    if (toggle && drawer) { e.preventDefault(); drawerOpen(); return; }
    if (t.closest('[data-kb-drawer-close]')) { drawerClose(); return; }
    var q = t.closest('[data-kb-qty]');
    if (q) { changeLine(parseInt(q.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-qty'), 10) + parseInt(q.getAttribute('data-kb-qty'), 10)); return; }
    var rm = t.closest('[data-kb-line-remove]');
    if (rm) { changeLine(parseInt(rm.getAttribute('data-line'), 10), 0); return; }
    var qa = t.closest('[data-kb-quick-add]');
    if (qa && !qa.disabled) {
      e.preventDefault();
      qa.classList.add('is-loading'); qa.disabled = true;
      addToCart({ id: parseInt(qa.getAttribute('data-variant-id'), 10), quantity: 1 })
        .then(function () { drawerOpen(); })
        .catch(function (err) { toast(err.message, true); })
        .then(function () { qa.classList.remove('is-loading'); qa.disabled = false; });
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    drawerClose();
    var f = $('[data-kb-filters]'); if (f && f.getAttribute('aria-hidden') === 'false') filtersToggle(false);
  });

  /* ---------- Producto ---------- */
  // Galería: una imagen destacada y las demás como miniaturas que pasan a ser la destacada al hacer clic
  function setFeatured(sec, index) {
    var items = $$('.kb-gal__item', sec), thumbs = $$('[data-kb-thumb]', sec);
    if (!items.length) return;
    index = (index + items.length) % items.length;
    items.forEach(function (it, i) { it.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var img = $('img', items[index]);
    if (img && img.loading === 'lazy') img.loading = 'eager';
  }
  function featuredIndex(sec) {
    var items = $$('.kb-gal__item', sec);
    for (var i = 0; i < items.length; i++) if (items[i].classList.contains('is-active')) return i;
    return 0;
  }
  function scrollGalleryTo(sec, mediaId) {
    var item = $('.kb-gal__item[data-media-id="' + mediaId + '"]', sec);
    if (!item) return;
    setFeatured(sec, parseInt(item.getAttribute('data-index'), 10) || 0);
  }

  function initProduct(sec) {
    if (sec.__kbP) return; sec.__kbP = true;
    var jsonEl = $('[data-kb-variants]', sec); if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent || '[]');
    var form = $('form.kb-buy', sec);
    var idInput = $('[data-kb-variant-id]', sec);
    var groups = $$('[data-kb-opt]', sec);
    var addBtns = $$('[data-kb-add], [data-kb-sticky-add]', sec);
    var priceNow = $('[data-kb-price-now]', sec), priceWas = $('[data-kb-price-was]', sec), pricePct = $('[data-kb-price-pct]', sec);
    var stockEl = $('[data-kb-stock]', sec), stickyPrice = $('[data-kb-sticky-price]', sec);
    var msg = $('[data-kb-buy-msg]', sec);

    function selection() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function find(sel) { return data.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); })[0]; }

    function labels(text) {
      addBtns.forEach(function (b) { var l = $('[data-kb-add-label]', b); if (l) l.textContent = text; });
    }
    function update(fromUser) {
      var sel = selection();
      groups.forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var t = sel.slice(); t[gi] = inp.value;
          var ok = data.some(function (v) { return v.available && v.options.every(function (o, i) { return t[i] === o; }); });
          var l = $('label[for="' + inp.id + '"]', g); if (l) l.classList.toggle('is-off', !ok);
        });
        var out = $('[data-kb-opt-val]', g); if (out) out.textContent = sel[gi] || '';
      });
      var v = find(sel);
      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; });
        labels(S.unavailable || 'No disponible');
        return;
      }
      if (idInput) idInput.value = v.id;
      if (fromUser && w.history && w.history.replaceState) {
        try { w.history.replaceState(null, '', w.location.pathname + '?variant=' + v.id); } catch (e) {}
      }
      var onSale = v.compare > v.price;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = money(v.compare); }
      if (pricePct) { pricePct.hidden = !onSale; if (onSale) pricePct.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%'; }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      addBtns.forEach(function (b) { b.disabled = !v.available; });
      labels(v.available ? (S.add || 'Agregar a la bolsa') : (S.soldOut || 'Agotado'));
      if (stockEl) {
        var th = parseInt(stockEl.getAttribute('data-threshold'), 10) || 10;
        var low = v.available && v.tracked && v.qty > 0 && v.qty <= th;
        stockEl.hidden = !low;
        stockEl.classList.toggle('is-low', low);
        stockEl.textContent = low ? 'Quedan ' + v.qty : '';
      }
      if (fromUser && v.media) scrollGalleryTo(sec, v.media);
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    update(false);

    // cantidad
    $$('[data-kb-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('.kb-qty__input', b.parentElement); if (!inp) return;
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-kb-step'), 10));
      });
    });

    // agregar a la bolsa
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtns[0] && addBtns[0].disabled) return;
        addBtns.forEach(function (b) { b.classList.add('is-loading'); });
        if (msg) msg.hidden = true;
        addToCart(new FormData(form))
          .then(function () { drawerOpen(); })
          .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } else toast(err.message, true); })
          .then(function () { addBtns.forEach(function (b) { b.classList.remove('is-loading'); }); });
      });
    }

    // miniaturas y deslizamiento para cambiar la imagen destacada
    var thumbsEl = $('[data-kb-thumbs]', sec);
    if (thumbsEl) thumbsEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kb-thumb]');
      if (t) setFeatured(sec, parseInt(t.getAttribute('data-kb-thumb'), 10) || 0);
    });
    var stageEl = $('[data-kb-gal]', sec);
    if (stageEl && thumbsEl) {
      var x0 = null, y0 = null;
      stageEl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stageEl.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) setFeatured(sec, featuredIndex(sec) + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // barra de compra fija
    var sticky = $('[data-kb-sticky]', sec), buy = $('[data-kb-buy]', sec);
    if (sticky && buy && 'IntersectionObserver' in w) {
      new w.IntersectionObserver(function (es) {
        var en = es[0], on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var sb = $('[data-kb-sticky-add]', sticky); if (sb) sb.tabIndex = on ? 0 : -1;
      }).observe(buy);
    }

    // imagen ampliada
    var lb = $('[data-kb-lightbox]', sec), stage = lb ? $('[data-kb-lightbox-stage]', lb) : null;
    var zooms = $$('[data-kb-zoom]', sec), cur = 0;
    function bigSrc(btn) {
      var img = $('img', btn); if (!img) return '';
      var ss = img.getAttribute('srcset');
      return ss ? ss.split(',').pop().trim().split(/\s+/)[0] : img.src;
    }
    function show(i) {
      cur = (i + zooms.length) % zooms.length;
      var img = d.createElement('img'); img.src = bigSrc(zooms[cur]); img.alt = ($('img', zooms[cur]) || {}).alt || '';
      stage.textContent = ''; stage.appendChild(img);
    }
    if (lb && stage && zooms.length) {
      zooms.forEach(function (z) {
        z.addEventListener('click', function () {
          show(parseInt(z.getAttribute('data-kb-zoom'), 10));
          if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
          if (KB.lock) KB.lock(true);
        });
      });
      var closeLb = function () { if (lb.close) lb.close(); else lb.removeAttribute('open'); };
      lb.addEventListener('close', function () { if (KB.lock) KB.lock(false); });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-kb-lightbox-close]') || e.target === lb || e.target === stage) { closeLb(); return; }
        var nav = e.target.closest('[data-kb-lightbox-nav]'); if (nav) show(cur + parseInt(nav.getAttribute('data-kb-lightbox-nav'), 10));
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(cur + 1);
        if (e.key === 'ArrowLeft') show(cur - 1);
      });
    }
  }

  /* ---------- Colección ---------- */
  var filters = null, filtersFocus = null;
  function filtersToggle(open) {
    if (!filters) return;
    var isOpen = filters.getAttribute('aria-hidden') === 'false';
    if (open === isOpen) return;
    filters.setAttribute('aria-hidden', open ? 'false' : 'true');
    $$('[data-kb-filters-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (KB.lock) KB.lock(open);
    if (open) { filtersFocus = d.activeElement; var p = $('.kb-filters__panel', filters); if (p) p.focus({ preventScroll: true }); }
    else if (filtersFocus && filtersFocus.focus) filtersFocus.focus({ preventScroll: true });
  }

  function initCollection(sec) {
    if (sec.__kbC) return; sec.__kbC = true;
    filters = $('[data-kb-filters]', sec);
    $$('[data-kb-filters-open]', sec).forEach(function (b) { b.addEventListener('click', function () { filtersToggle(true); }); });
    $$('[data-kb-filters-close]', sec).forEach(function (b) { b.addEventListener('click', function () { filtersToggle(false); }); });

    var sort = $('[data-kb-sort]', sec);
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

    // columnas
    var btns = $$('[data-kb-density]', sec);
    function setCols(n, persist) {
      sec.setAttribute('data-cols', n);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kb-density') === String(n) ? 'true' : 'false'); });
      if (persist) { try { w.localStorage.setItem('kb-cols', String(n)); } catch (e) {} }
    }
    var saved = null; try { saved = w.localStorage.getItem('kb-cols'); } catch (e) {}
    setCols(saved || sec.getAttribute('data-cols') || '3', false);
    btns.forEach(function (b) { b.addEventListener('click', function () { setCols(b.getAttribute('data-kb-density'), true); }); });

    // cargar más
    var more = $('[data-kb-loadmore]', sec), grid = $('[data-kb-grid]', sec);
    if (more && grid) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        var label = more.textContent; more.textContent = S.loading || 'Cargando…'; more.classList.add('is-loading');
        fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          $$('[data-kb-grid] > .kb-card', doc).forEach(function (c) { grid.appendChild(d.importNode(c, true)); });
          var nextBtn = $('[data-kb-loadmore]', doc);
          if (nextBtn) { more.href = nextBtn.getAttribute('href'); more.textContent = label; more.classList.remove('is-loading'); }
          else { var pager = more.closest('[data-kb-pager]'); if (pager) pager.remove(); }
          if (KB.scan) KB.scan(grid);
        }).catch(function () { w.location.href = more.href; });
      });
    }
  }

  /* ---------- Recomendaciones ---------- */
  function initRecs(el) {
    if (el.__kbRecs) return; el.__kbRecs = true;
    if ($('.kb-card', el)) { if (KB.scan) KB.scan(el); return; }
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = $('[data-kb-recs]', doc);
      if (inner && $('.kb-card', inner)) { el.innerHTML = inner.innerHTML; if (KB.scan) KB.scan(el); }
    }).catch(function () {});
  }

  function init(scope) {
    scope = scope || d;
    $$('[data-kb-product]', scope).forEach(initProduct);
    $$('[data-kb-collection]', scope).forEach(initCollection);
    $$('[data-kb-recs]', scope).forEach(initRecs);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
